/**
 * 管理画面・申請詳細でカテゴリごとに非表示にする formData キー
 */
const HIDDEN_KEYS = {
    VACATION:   new Set(["leave_type", "application_date"]),
    HOLIDAY_WORK: new Set(["leave_type"]),
    // 退職：applicationDate は上部カードで表示済みのため、formData 内は非表示
    RETIREMENT: new Set(["leave_type", "resignDate", "applicationDate", "application_date"]),
    RESIGN:     new Set(["leave_type", "resignDate"]),
    // 異動年月日：start_date/end_date/created_at を非表示。applicationDate または application_date のみ「異動年月日」で表示
    REMOVE:     new Set(["leave_type", "start_date", "end_date", "startDate", "endDate", "created_at", "create_at"]),
    MYNUMBER:   new Set(["application_type", "applicationType"]),
    // 住所変更：申請日は上部カードで表示済みのため formData 内の created_at/create_at は非表示
    ADDRESS:    new Set(["created_at", "create_at"]),
    // 残業・遅刻・早退：内部計算用の「分」フィールドは非表示
    OVERTIME:   new Set(["overtimeMinutes"]),
    LATE_IN:    new Set(["lateMinutes"]),
    EARLY_OUT:  new Set(["earlyLeaveMinutes"]),
};

/** カテゴリごとの表示順 */
const CATEGORY_KEY_ORDER = {
    // 有給申請：有給日（selectedDates or start_date/end_date）、申請理由、日数
    VACATION:     ['selectedDates', 'start_date', 'end_date', 'reason', 'days'],
    // 休日出勤：出勤日、区分（振替か）、振替日、勤務時間、休憩、理由
    HOLIDAY_WORK: ['selectedDates', 'isFurikae', 'substituteDates', 'substituteDate', 'workStartTime', 'workEndTime', 'breakTime', 'reason'],
    ADDRESS:      ['oldZipCode', 'oldAddress', 'oldAddressKana', 'newZipCode', 'newAddress', 'newAddressKana'],
    NAME_CHANGE:  ['oldName', 'oldKanaName', 'newName', 'newKanaName'],
    // 異動年月日：異動年月日（applicationDate or application_date）、理由の順
    REMOVE:       ['applicationDate', 'application_date', 'reason'],
    // 退職：入社日（startDate/start_date）、退社日（endDate/end_date）、理由の順
    RETIREMENT:   ['startDate', 'start_date', 'endDate', 'end_date', 'reason'],
    SPECIAL_LEAVE:['start_date', 'end_date', 'reason'],
    // 日帰り申請：日付、出張用件、出張時間、利用交通機関、金額
    TRANSPORT_ROUND: ['targetDate', 'businessPurpose', 'businessStartTime', 'businessEndTime', 'routes', 'amount'],
    // 諸手当：家族→住宅→派遣→都市→資格→合計
    ALLOWANCE: ['familyAllowance', 'housingAllowance', 'dispatchAllowance', 'cityAllowance', 'qualificationAllowance', 'totalAllowance'],
    // マイナンバー：個人番号のみ（申請日は上部カードに表示）
    MYNUMBER:     ['myNumber', 'image'],
    // 残業申請：残業日 → 予定 → 実績 → 残業時間 → 理由 → 補足（算出方法・上司承認の省略）
    OVERTIME: [
        'overtime_date',
        'overtime_end_time',
        'scheduled_end', 'overtime_end', 'actual_end',
        'overtime_hours', 'break_hours',
        'reason', 'deviation_reason',
        'overtime_source', 'supervisor_skipped',
    ],
    // 早退申請：早退日、開始/終了時刻、早退時間、理由
    EARLY_OUT:    ['early_out_date', 'startTime', 'endTime', 'early_out_hours', 'reason'],
    // 遅刻申請：遅刻日、開始/終了時刻、遅刻時間、理由
    LATE_IN:      ['late_date', 'startTime', 'endTime', 'late_hours', 'reason'],
    // 入社届：基本情報→住所→連絡先→銀行→通勤情報の順
    joined: [
        'startDate', 'name', 'nameFuri', 'birthDate',
        'zipCode', 'address',
        'contact1', 'contact2',
        'bankName', 'branchName', 'branchNameKana', 'accountNumber',
        'transport', 'road', 'station', 'fare',
        'extraTrains',
    ],
};

export function shouldHideFormKey(category, key) {
    const set = HIDDEN_KEYS[category];
    if (!set) return false;
    return set.has(key);
}

/** 申請詳細用にエントリをフィルタ＋カテゴリ定義順にソート */
export function filterFormEntries(category, form) {
    if (!form || typeof form !== "object") return [];
    const allEntries = Object.entries(form).filter(([k]) => !shouldHideFormKey(category, k));

    const order = CATEGORY_KEY_ORDER[category];
    if (!order) return allEntries;

    const ordered = [];
    // 定義された順番で並べる
    for (const key of order) {
        const entry = allEntries.find(([k]) => k === key);
        if (entry) ordered.push(entry);
    }
    // 定義されていない残りのキーを末尾に追加
    for (const entry of allEntries) {
        if (!order.includes(entry[0])) ordered.push(entry);
    }
    return ordered;
}
